class FieldProp {
    required: boolean;
    label: string;
    name: string;
    constructor(props: Partial<FieldProp>) {
        Object.assign(this, props);
    }
}

export default FieldProp;
